import React, { useEffect, useRef } from 'react';
import { useTest } from '../contexts/TestContext';
import SoundUtils from '../utils/SoundUtils';
import { gsap } from 'gsap';

const StartPage = () => {
  const { setStage } = useTest();
  const titleRef = useRef(null);
  const titleGlowRef = useRef(null);
  const subtitleRef = useRef(null);
  const buttonRef = useRef(null);
  const templeRef = useRef(null);
  const redlineRef = useRef(null);
  const overlayRef = useRef(null);
  const containerRef = useRef(null);

  // 處理開始測驗
  const handleStartTest = () => {
    // 播放按鈕音效
    SoundUtils.playButtonClick();

    // 黑色半透明底色淡出
    gsap.to(overlayRef.current, {
      opacity: 0,
      duration: 0.8,
      ease: "power2.inOut"
    });

    // 開始鏡頭3D運鏡效果
    gsap.timeline()
      .to(templeRef.current, {
        scale: 1.5,
        y: "-30%",
        xPercent: 0,
        yPercent: 0,
        transformOrigin: "center center",
        duration: 1.2,
        ease: "power2.inOut"
      })
      .to(titleRef.current, {
        opacity: 0,
        y: -50,
        duration: 0.5,
        ease: "power2.in"
      }, "-=0.8")
      .to(titleGlowRef.current, {
        opacity: 0,
        scale: 1.5,
        duration: 0.5,
        ease: "power2.in"
      }, "-=0.8")
      .to(subtitleRef.current, {
        opacity: 0,
        y: -50,
        duration: 0.5,
        ease: "power2.in"
      }, "-=0.7")
      .to(buttonRef.current, {
        opacity: 0,
        y: 50,
        duration: 0.5,
        ease: "power2.in"
      }, "-=0.6")
      .to(redlineRef.current, {
        opacity: 0.8,
        scale: 1.2,
        duration: 0.8,
        ease: "power2.inOut",
        onComplete: () => {
          SoundUtils.playTransition();
          setStage('questions');
        }
      }, "-=0.3");
  };

  // 初始動畫效果
  useEffect(() => {
    // 確保圖片加載完成
    const preloadImages = () => {
      const imageUrls = [
        '/assets/images/temple.png',
        '/assets/images/redline.png',
        '/assets/images/zonghan.png',
        '/assets/images/yuelao.png',
        '/assets/images/lantern.png'
      ];

      imageUrls.forEach(url => {
        const img = new Image();
        img.src = url;
      });
    };

    preloadImages();
    
    // 設置初始樣式確保背景圖片覆蓋整個屏幕
    gsap.set(templeRef.current, {
      width: '100%',
      height: '100%',
      position: 'fixed',
      top: 0,
      left: 0,
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
      transformOrigin: 'center center'
    });

    // 先淡入黑色半透明底色
    gsap.fromTo(overlayRef.current,
      { opacity: 0 },
      { opacity: 0.5, duration: 1, ease: "power2.out" }
    );

    // 初始動畫
    const tl = gsap.timeline({ delay: 0.5 });

    tl.fromTo(templeRef.current,
      { opacity: 0, scale: 1.2 },
      { opacity: 1, scale: 1, duration: 1.5, ease: "power3.out" }
    )
      .fromTo(redlineRef.current,
        { opacity: 0, scale: 0.5 },
        { opacity: 0.6, scale: 1, duration: 1.2, ease: "power3.out" },
        "-=1"
      )
      .fromTo(titleGlowRef.current,
        { opacity: 0, scale: 0.8 },
        { opacity: 0.8, scale: 1, duration: 1, ease: "power2.out" }
      )
      .fromTo(titleRef.current,
        { opacity: 0, y: 30 },
        { opacity: 1, y: 0, duration: 0.8, ease: "power2.out" },
        "-=0.7"
      )
      .fromTo(subtitleRef.current,
        { opacity: 0, y: 20 },
        { opacity: 1, y: 0, duration: 0.8, ease: "power2.out" },
        "-=0.5"
      )
      .fromTo(buttonRef.current,
        { opacity: 0, y: 20 },
        { opacity: 1, y: 0, duration: 0.8, ease: "power2.out" },
        "-=0.4"
      );

    // 紅線浮動動畫
    gsap.to(redlineRef.current, {
      y: 10,
      rotation: 2,
      duration: 3,
      ease: "sine.inOut",
      repeat: -1,
      yoyo: true,
      delay: 2
    });

    // 標題光暈呼吸效果
    gsap.to(titleGlowRef.current, {
      opacity: 0.6,
      scale: 1.2,
      duration: 2.5,
      ease: "sine.inOut",
      repeat: -1,
      yoyo: true,
      delay: 1
    });
  }, []);

  return (
    <div className="start-page">
      <div className="temple-background" ref={templeRef}></div>
      <div className="red-lines" ref={redlineRef}></div>
      <div className="overlay" ref={overlayRef}></div>

      <div className="content-container" ref={containerRef}>
        <div className="title-container">
          <h1 className="main-title" ref={titleRef}>
            我適合什麼類型的戀人
          </h1>
          <div className="title-glow" ref={titleGlowRef}></div>
        </div>
        <h2 className="subtitle" ref={subtitleRef}>
          在愛情中，你最喜歡戀人的模樣是？
        </h2>
        <button className="start-button" ref={buttonRef} onClick={handleStartTest}>
          開始測驗
        </button>
      </div>
    </div>
  );
};

export default StartPage;